// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","about":"about_about__lOW1R","container":"about_container__IB7IR","aboutInner":"about_aboutInner__A4MXo","btns":"about_btns__yAK2W"};